import useCopyToClipboard from '@unifyapps/carbon/hooks/useCopyToClipboard';
import { useCallback } from 'react';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { getCopyText } from './utils/getCopyText';
import type { Serializable } from './utils/getStringifiedCopyPath';

const useCopyToClipboardAction = () => {
  const { getNoCodeComputedData } = useGetNoCodeComputedData();
  const { handleCopy } = useCopyToClipboard({ suppressSnackbar: true });

  const handleCopyAction: ActionHandlerType = useCallback(
    ({ action, actionContext }: OnActionArgs) => {
      const payload = action.payload as { value: string };

      const { value } = getNoCodeComputedData<{
        value: unknown;
      }>(
        {
          value: payload.value,
        },
        actionContext,
      );

      handleCopy(typeof value === 'string' ? value : getCopyText(value as Serializable));
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [getNoCodeComputedData, handleCopy],
  );

  return { handleCopyAction };
};

export default useCopyToClipboardAction;
